import { useContext } from 'react';
import { ErrorLoggerContext } from './context.mjs';

function useErrorLogger() {
  return useContext(ErrorLoggerContext);
}

export { useErrorLogger };
